<template>
  <div class="sub6">

    <lnb></lnb>

    <!--SECTION-->
    <section class="sec1">
      <img src="img/visual_sub6.png" alt="" class="bg">
      <div class="search_area">
        <input type="text" id="search" placeholder="검색하기" @keyup.enter="changeContentsName('Sub7')">
        <a @click="changeContentsName('Sub7')"><img src="img/btn_search.png" alt="" class="submit"></a>
      </div>
    </section>

  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import Lnb from './Lnb.vue'

  export default {
    name: 'Sub6age',
    components: {
      Lnb
    },
    data () {
      return {

      }
    },
    methods: {
      ...mapMutations([
        'changeContentsName'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sub6Page.vue